/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Switchaccount1Inputs */

const en_switchaccount1 = /** @type {(inputs: Switchaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out and use another account`)
};

const de_switchaccount1 = /** @type {(inputs: Switchaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden und anderes Konto nutzen`)
};

/**
* | output |
* | --- |
* | "Sign out and use another account" |
*
* @param {Switchaccount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const switchaccount1 = /** @type {((inputs?: Switchaccount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switchaccount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_switchaccount1(inputs)
	return de_switchaccount1(inputs)
});
export { switchaccount1 as "switchAccount" }